import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor() { }

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL ADD FIN ==================-\\
  public ToggleModalAddFIN(CloseOrOpen: boolean): void {
    const ModalAddFIN = document.getElementById('ModalAddFIN') as HTMLDivElement;
    CloseOrOpen ? ModalAddFIN.classList.add('active') : ModalAddFIN.classList.remove('active');
  }


}
